import { render, staticRenderFns } from "./TypeOccurrenceStatus.vue?vue&type=template&id=347c45e9&"
import script from "./TypeOccurrenceStatus.vue?vue&type=script&lang=js&"
export * from "./TypeOccurrenceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports